import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getCasinoList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.betList.casino.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCasinoBetListFilters = () => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = `${api.admin.agents.casinoBetListFilters}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(endpoint, { ...RequestOptions('GET') })
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

export const casinoBetListService = {
  getCasinoList,
  getCasinoBetListFilters,
};
